import { Controller } from '@hotwired/stimulus';

export default class SupportButtonController extends Controller {
  static values = { fallbackUrl: String };

  open() {
    if (window.Beacon('info') !== undefined) {
      window.Beacon('open');
      return;
    }

    if (this.hasFallbackUrlValue) {
      if (window.Turbo !== undefined) {
        window.Turbo.visit(this.fallbackUrlValue);
      } else {
        window.location = this.fallbackUrlValue;
      }
    }
  }
}
